/*
 * @Author: cn1994
 * @Date: 2023-09-15 17:28:30
 * @LastEditors: cn1994
 * @LastEditTime: 2023-09-15 17:40:10
 * @Description: 机构store
 */
import { defineStore } from 'pinia'
import { useBaseStore } from './base'

export const useInstStore = defineStore('instStore', {

  state: () => {
    return {
      baseStore: useBaseStore()
    }
  },
  getters: {
    subject: (state) => {
      return state.baseStore.instInfo.subject
    },
    canGetGroupEducator: (state) => {
      return state.baseStore.instInfo.canGetGroupEducator == 'true' ? true : false
    },
    code: (state) => {
      return state.baseStore.instInfo.code
    },
    id: (state) => {
      return state.baseStore.instInfo.id
    },
    logoUrl: (state) => {
      return state.baseStore.instInfo.logoUrl
    },
    title: (state) => {
      return state.baseStore.instInfo.title
    },
    groupId: (state) => {
      return state.baseStore.instInfo.groupId
    },
    hasDubbing: (state) => {
      return state.baseStore.instInfo.hasDubbing == 'true' ? true : false
    },
    hasLiveHD: (state) => {
      return state.baseStore.instInfo.instExtendConfig.hasLiveHD == 'true' ? true : false
    },
    salerId: (state) => {
      return state.baseStore.instInfo.salerId
    },
    isContract: (state) => {
      return state.baseStore.instInfo.isContract == 'true' ? true : false
    },
    canTeacherArrangeCourse: (state) => {
      return state.baseStore.instInfo.canTeacherArrangeCourse == 'true' ? true : false
    },
    productType: (state) => {
      return state.baseStore.instInfo.instExtendConfig.productType
    },
    needReviewOrder: (state) => {
      return state.baseStore.instInfo.instExtendConfig.needReviewOrder == 'true' ? true : false
    },
    hasAutoDeduction: (state) => {
      return state.baseStore.instInfo.instExtendConfig.hasAutoDeduction == 'true' ? true : false
    },
    hasLightWeight: (state) => {
      return state.baseStore.instInfo.hasLightWeight == 'true' ? true : false
    },
    branchParentId: (state) => {
      return state.baseStore.instInfo.branchParentId
    },
    courseType: (state) => {
      return state.baseStore.instInfo.courseType
    },
    hasExam: (state) => {
      return state.baseStore.instInfo.hasExam == 'true' ? true : false
    },
    customerProductType: (state) => {
      return state.baseStore.instInfo.customerProductType
    },
    hasPublicTextbooks: (state) => {
      return state.baseStore.instInfo.hasPublicTextbooks == 'true' ? true : false
    },
    normalManagerShowTytyMall: (state) => {
      return state.baseStore.instInfo.instExtendConfig.normalManagerShowTytyMall == 'true' ? true : false
    },
    canAddOrdinaryCourse: (state) => {
      return state.baseStore.instInfo.instExtendConfig.canAddOrdinaryCourse == 'true' ? true : false
    },
    useNewestHomepage: (state) => {
      return state.baseStore.instInfo.instExtendConfig.useNewestHomepage == 'true' ? true : false
    },
    multidisciplinaryMainInstId: (state) => {
      return state.baseStore.instInfo.multidisciplinaryMainInstId
    },
    showPublicLibrary: (state) => {
      return state.baseStore.instInfo.showPublicLibrary == 'true' ? true : false
    },
    hasOpenRegistration: (state) => {
      return state.baseStore.instInfo.instExtendConfig.hasOpenRegistration == 'true' ? true : false
    },
    enableRegistrationReview: (state) => {
      return state.baseStore.instInfo.instExtendConfig.enableRegistrationReview == 'true' ? true : false
    },
    hasAssignmentAndCourseV2: (state) => {
      return state.baseStore.instInfo.hasAssignmentAndCourseV2 == 'true' ? true : false
    },
    rateFlower: (state) => {
      return state.baseStore.instInfo.rateFlower
    },
    rateThumb: (state) => {
      return state.baseStore.instInfo.rateThumb
    },
    rateStar: (state) => {
      return state.baseStore.instInfo.rateStar
    },
    hasControlShareApp: (state) => {
      return state.baseStore.instInfo.instExtendConfig.hasControlShareApp == 'true' ? true : false
    },
    serverId: (state) => {
      return state.baseStore.instInfo.serverId
    },
    medicalType: (state) => {
      return state.baseStore.instInfo.instExtendConfig.medicalType
    },
    stillUseOrdinaryCourseTime: (state) => {
      return state.baseStore.instInfo.instExtendConfig.stillUseOrdinaryCourseTime == 'true' ? true : false
    },
    canLevelTest: (state) => {
      return state.baseStore.instInfo.instExtendConfig.canLevelTest == 'true' || state.baseStore.instInfo.canLevelTest == 'true' ? true : false
    },
    hasUgc: (state) => {
      return state.baseStore.instInfo.hasUgc == 'true' ? true : false
    },
    hasApp: (state) => {
      return state.baseStore.instInfo.hasApp == 'true' ? true : false
    },
    isInstPayment: (state) => {
      return state.baseStore.instInfo.isInstPayment == 'true' ? true : false
    },
    hasOpenCodeRegistration: (state) => {
      return state.baseStore.instInfo.instExtendConfig.hasOpenCodeRegistration == 'true' ? true : false
    },
    supportRememberWord: (state) => {
      return state.baseStore.instInfo.supportRememberWord == 'true' ? true : false;
    }
  },
  actions: {
    
  },
  persist:
  {
    storage: sessionStorage,
    enabled: true
  }
})